import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { datricApi } from '../../../services/api/datric.api';
import { Integration, IntegrationType, UpdateIntegrationPayload } from '../../../models/integration.model';
import { toastService } from '../../../services/toast.service';

export interface IntegrationState {
	list: Integration[];
	loading: boolean;
}

const initialState: IntegrationState = {
	list: [],
	loading: false
};

export const fetchIntegrations = createAsyncThunk('integration/list', async () => {
	return datricApi.integration.list();
});

export const saveIntegration = createAsyncThunk(
	'integration/save',
	async (payload: { type: IntegrationType; data: UpdateIntegrationPayload }, { dispatch, rejectWithValue }) => {
		try {
			const res = await datricApi.integration.update(payload.type, payload.data);
			toastService.success('Integração atualizada');
			dispatch(fetchIntegrations());
			return res;
		} catch (e: any) {
			toastService.error(typeof e === 'string' ? e : 'Falha ao salvar integração');
			return rejectWithValue(e);
		}
	}
);

export const integrationSlice = createSlice({
	name: 'integration',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchIntegrations.pending, state => {
			state.loading = true;
		});
		builder.addCase(fetchIntegrations.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload as Integration[];
		});
		builder.addCase(fetchIntegrations.rejected, state => {
			state.loading = false;
		});
	}
});
